<template>
  <div>
    <div class="header py-7 py-lg-4 pt-lg-9"></div>
    <b-container class="mt--8 pb-5" style="max-width: 900px !important">
      <base-header class="pb-6 bg-primary">
        <b-row class="align-items-center py-4">
          <b-col />
        </b-row>
      </base-header>
      <div class="px-0 px-sm-3 mt--12">
        <b-card no-body class="mb-4 px-0">
          <div class="container-fluid px-3 py-5">
            <b-card class="uBind">
              <h2>Email preferences</h2>

              <div v-if="isLoading" class="text-muted">Please wait…</div>

              <div v-else-if="errorMessage" class="text-danger">
                {{ errorMessage }}
              </div>

              <div v-else-if="status === 'optedOut'">
                <p>
                  You have been opted out of further emails from the
                  YourInsuranceHQ platform.
                </p>
                <p v-if="optedOutAt" class="text-muted">
                  Opted out at {{ optedOutAt }}.
                </p>
              </div>

              <div v-else-if="status === 'cancelled'">
                <p>
                  No changes were made. You will continue to receive emails from
                  YourInsuranceHQ.
                </p>
              </div>

              <div v-else>
                <p>
                  Are you sure you want to opt out of receiving any further
                  emails from the YourInsuranceHQ platform?
                </p>
                <div class="mt-4">
                  <b-button variant="danger" class="mr-2" @click="confirmOptOut">
                    Yes, opt me out
                  </b-button>
                  <b-button variant="secondary" @click="cancelOptOut">
                    No, keep me subscribed
                  </b-button>
                </div>
              </div>
            </b-card>
          </div>
        </b-card>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CustomerEmailOptOut",
  data() {
    return {
      isLoading: false,
      errorMessage: "",
      status: "",
      optedOutAt: ""
    };
  },
  computed: {
    token() {
      return this.$route.params.token || "";
    }
  },
  mounted() {
    if (!this.token) {
      this.errorMessage = "Missing opt-out reference.";
    }
  },
  methods: {
    async confirmOptOut() {
      if (!this.token) {
        this.errorMessage = "Missing opt-out reference.";
        return;
      }

      this.isLoading = true;
      this.errorMessage = "";

      try {
        const base = (process.env.VUE_APP_APIENDPOINT || "").replace(/\/$/, "");
        if (!base) {
          throw new Error("API endpoint is not configured.");
        }

        const resp = await axios.post(`${base}/live/customer/optOut`, {
          token: this.token
        });

        this.status = "optedOut";
        const at = resp && resp.data && resp.data.optedOutAt;
        this.optedOutAt = at ? new Date(at).toLocaleString() : "";
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.error) ||
          (e && e.message) ||
          "Unable to complete opt-out.";
        this.errorMessage = msg;
      } finally {
        this.isLoading = false;
      }
    },
    cancelOptOut() {
      this.status = "cancelled";
    }
  }
};
</script>
